var SIGN_IN_BUTTON_KEY = 'signIn';
var SIGN_UP_BUTTON_KEY = 'signUp';

export { SIGN_IN_BUTTON_KEY, SIGN_UP_BUTTON_KEY };
